import React from 'react';
import styled from 'styled-components';

import Cell from './common/Cell';
import DataCell from './common/DataCell';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';

export interface IWorkModeAreaProps {}
const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`;
const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
`;
const AnalysisContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
`;
const CellContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export default function WorkModeArea(props: IWorkModeAreaProps) {
  return (
    <Container>
      <FilterContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-1" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-1" />
          </DataCell>
        </CellContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-2" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-2" />
          </DataCell>
        </CellContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-3" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-3" />
          </DataCell>
        </CellContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-4" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-4" />
          </DataCell>
        </CellContainer>
      </FilterContainer>
      <AnalysisContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-5" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-5" />
          </DataCell>
        </CellContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-6" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-6" />
          </DataCell>
        </CellContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-7" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-7" />
          </DataCell>
        </CellContainer>
        <CellContainer>
          <Cell width="30%">
            <MonitorLabel field="work-mode-area-8" />
          </Cell>
          <DataCell width="70%">
            <MonitorField field="work-mode-area-8" />
          </DataCell>
        </CellContainer>
      </AnalysisContainer>
    </Container>
  );
}
